import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import axios from "axios";
import { create } from "zustand";
import { ProductCart } from "../Home/components/productCard";
import TrackLinkCard from "../Home/components/trackLinkCard";
import { ViewCart } from "../Home/components/viewCart";
import { PaymentQuery } from "../Home/components/PaymentQuery";

const appstore = create((set, get) => ({
  isConnected: false,
  messages: [],
  botDetails: {},
  roomId: "",
  showTyping: false,
  sessionId: "",
  mycart: {},
  botSessionId: "",
  productPageLoading: false,
  cartId:"",
  origin:"",
  href:"",
  setHref:(data)=>{
    set({ href: data });
  },
  setOrigin:(data)=>{
    set({ origin: data });
  },
 setCartId :(data) => {
    set({ cartId: data });
  },
  setStoreUrl: (data) => {
    set({ storeURl: data });
  },
  setProductPageLoading: (data) => {
    set({ productPageLoading: data });
  },
  setBotSessionId: (data) => {
    set({ botSessionId: data });
  },
  suggestions: [
    "Show me some products",
    "What is the trending product",
    "What are the products you are selling?",
  ],
  showSuggestions: false,
  cartList: localStorage.getItem("cartList") || [],
  setSessionId: (data) =>
    set({
      sessionId: data,
    }),
  setCart: (data) => set({ mycart: data }),
  setSuggestions: (data) => set({ suggestions: data }),
  setShowTyping: (data) => set({ showTyping: data }),
  setBotDetails: (data) => set({ botDetails: data }),
  setRoomId: (data) => set({ roomId: data }),
  setIsConnected: (status) => set({ isConnected: status }),
  setMessages: (data, isUser, time) => {
    set(() => ({
      messages: [...get().messages, { text: data, user: isUser, time: time }],
    }));
  },
  setMessagesToNewChat: () => {
    set(() => ({
      messages: [],
    }));
  },

  setCartList: (data) => set({ cartList: data }),
  setShowSuggestions: (data) => set({ showSuggestions: data }),
  clearCart: async () => {
    if (get().botDetails?.storeName === "Shopify") {
      const response = await fetch(
        window.Shopify.routes.root + "cart/clear.js",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          return error;
        });
      get().setCart(response);
      get().addCreateCartUlai(
        response.token,
        get().botDetails.userId,
        [],
        Number(0),
        Number(0)
      );
    } else if (get().botDetails?.storeName === "Bigcommerce") {
      const options = {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: ``,
      };
      let token = localStorage.getItem("cartId");
      // console.log("localStorage", localStorage.getItem("cartId"));
      await fetch(`/api/storefront/carts/${token}}`, options)
        .then((response) => {
          get().setCart({});
          get().addCreateCartUlai(
            token,
            get().botDetails.userId,
            [],
            Number(0),
            Number(0)
          );
        })
        .catch((err) => console.error(err));
    }
  },
  messageType: (data, isUser, time) => {
    // console.log("========>messageTypemessageType", data);
    appstore.getState().setShowTyping(false);
    // console.log("messageType", data, isUser, time);
    if(data?.openAiResponse?.paymentQuery){
      // console.log("============+> heyre")
      const currentTime = time
      ? new Date(time * 1000).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

    const text = <PaymentQuery botDetails={get().botDetails} />;
    return get().setMessages(text, isUser ? isUser : false, currentTime);
    }
    else if (
      (typeof data.viewCart == "object" &&
        Object.keys(data.viewCart).length > 0) ||
      (typeof data.viewCart == "boolean" && data.viewCart)
    ) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

      const text = <ViewCart botDetails={get().botDetails} />;
      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data?.openAiResponse?.links?.length > 0) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

      const isYouTubeLink = (url) => {
        return /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/.test(
          url
        );
      };

      const text = data.openAiResponse?.links.map((ele, i) => {
        const isYouTube = isYouTubeLink(ele); // Check if the link is a YouTube link

        return (
          <div
            key={i}
            style={{
              display: "flex", // Align icon and text horizontally
              alignItems: "center", // Vertical alignment
              textDecoration: "none",
              width: "100%",
              maxWidth: "320px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {/* Clickable Icon */}
            {isYouTube ? null : (
              <a
                href={ele}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginRight: "8px", // Space between icon and text
                  textDecoration: "none",
                  color: "inherit", // Use inheriting text color
                  display: "inline-block",
                }}
              >
                🔗
              </a>
            )}

            {/* Check if the link is a YouTube link */}
            {isYouTube ? (
              // Render embedded YouTube iframe
              <iframe
                // width="320"
                // height="320"
                src={`https://www.youtube.com/embed/${ele.split("v=")[1]}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube Video"
                style={{
                  marginTop: "8px",
                  maxWidth: "320px",
                  maxHeight: "320px",
                }}
              />
            ) : (
              // Render clickable Text for regular links
              <a
                href={ele}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: 1, // Take remaining space
                  color: "blue", // Use inheriting text color
                }}
              >
                {ele}
              </a>
            )}
          </div>
        );
      });

      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data.productList && data.productList.length !== 0) {
      window.parent.postMessage({ type: "ShopifyCall",shopifyCall:true }, "*");
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
      if (data.message !== "") {
        get().setMessages(data.message, isUser ? isUser : false, currentTime);
      }

      {
        data.productList.map((ele, indx) => {
          const currentTime = time
            ? new Date(time * 1000).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
          const text = (
            <ProductCart indx={indx} ele={ele} botDetails={get().botDetails} />
          );

          return get().setMessages(text, isUser ? isUser : false, currentTime);
        });
      }
    } else if (data?.openAiResponse?.message.includes("https://")) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
      let urlRegex = /(https?:\/\/[^\s]+)/g;
      let extractedUrl = data.message.match(urlRegex)[0];
      let modifiedString = data.message.replace(urlRegex, "").trim();
      let text = <TrackLinkCard msg={modifiedString} link={extractedUrl} />;
      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data.openAiResponse?.editCart?.length) {
      // console.log("Called-editCart");
      let editCarts = data.openAiResponse?.editCart[0];
      let method =
        editCarts[3] == "+" ? "Add" : editCarts[3] == "-" ? "Minus" : "Equal";
      get().handleQty(editCarts[4], editCarts[2], editCarts[1], "", method);
    } else {
      if (data?.openAiResponse?.clearCart) {
        get().clearCart();
      }
      // const currentTime = time
      //   ? new Date(time * 1000).toLocaleTimeString([], {
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     })
      //   : new Date().toLocaleTimeString([], {
      //       hour: "2-digit",
      //       minute: "2-digit",
      //       hour12: true,
      //     });
      // return get().setMessages(
      //   data.message,
      //   isUser ? isUser : false,
      //   currentTime
      // );
    }

    // Function to create or retrieve a session linked to a parameter
  },
  messageTypev2: (data, isUser, time) => {
    appstore.getState().setShowTyping(false);
    // console.log("messageType", data, isUser, time);

    if(data?.openAiResponse?.paymentQuery){
      // console.log("============+> heyre")
      const currentTime = time
      ? new Date(time * 1000).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

    const text = <PaymentQuery botDetails={get().botDetails} />;
    return get().setMessages(text, isUser ? isUser : false, currentTime);
    }

    else if (
      (typeof data.viewCart == "object" &&
        Object.keys(data.viewCart).length > 0) ||
      (typeof data.viewCart == "boolean" && data.viewCart)
    ) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

      const text = <ViewCart botDetails={get().botDetails} />;
      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data?.openAiResponse?.links?.length > 0) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

      const isYouTubeLink = (url) => {
        return /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/.test(
          url
        );
      };

      const text = data.openAiResponse?.links.map((ele, i) => {
        const isYouTube = isYouTubeLink(ele); // Check if the link is a YouTube link

        return (
          <div
            key={i}
            style={{
              display: "flex", // Align icon and text horizontally
              alignItems: "center", // Vertical alignment
              textDecoration: "none",
              width: "100%",
              maxWidth: "320px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {/* Clickable Icon */}
            {isYouTube ? null : (
              <a
                href={ele}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginRight: "8px", // Space between icon and text
                  textDecoration: "none",
                  color: "inherit", // Use inheriting text color
                  display: "inline-block",
                }}
              >
                🔗
              </a>
            )}

            {/* Check if the link is a YouTube link */}
            {isYouTube ? (
              // Render embedded YouTube iframe
              <iframe
                // width="320"
                // height="320"
                src={`https://www.youtube.com/embed/${ele.split("v=")[1]}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube Video"
                style={{
                  marginTop: "8px",
                  maxWidth: "320px",
                  maxHeight: "320px",
                }}
              />
            ) : (
              // Render clickable Text for regular links
              <a
                href={ele}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: 1, // Take remaining space
                  color: "blue", // Use inheriting text color
                }}
              >
                {ele}
              </a>
            )}
          </div>
        );
      });

      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data.productList && data.productList.length !== 0) {
      // appstore.getState().getShopifyCart();
      window.parent.postMessage({ type: "ShopifyCall",shopifyCall:true }, "*");
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
      if (data.message !== "") {
        get().setMessages(data.message, isUser ? isUser : false, currentTime);
      }

      {
        data.productList.map((ele, indx) => {
          const currentTime = time
            ? new Date(time * 1000).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
          const text = (
            <ProductCart ele={ele} indx={indx} botDetails={get().botDetails} />
          );

          return get().setMessages(text, isUser ? isUser : false, currentTime);
        });
      }
    } else if (data.message?.includes("https://")) {
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
      let urlRegex = /(https?:\/\/[^\s]+)/g;
      let extractedUrl = data.message.match(urlRegex)[0];
      let modifiedString = data.message.replace(urlRegex, "").trim();
      let text = <TrackLinkCard msg={modifiedString} link={extractedUrl} />;
      return get().setMessages(text, isUser ? isUser : false, currentTime);
    } else if (data.openAiResponse?.editCart?.length) {
      let editCarts = data.openAiResponse?.editCart[0];
      let method =
        editCarts[3] == "+" ? "Add" : editCarts[3] == "-" ? "Minus" : "Equal";
      get().handleQty(editCarts[4], editCarts[2], editCarts[1], "", method);
    } else {
      if (data?.openAiResponse?.clearCart) {
        get().clearCart();
      }
      const currentTime = time
        ? new Date(time * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
      return get().setMessages(
        data.message,
        isUser ? isUser : false,
        currentTime
      );
    }

    // Function to create or retrieve a session linked to a parameter
  },
  existingMessage: (data) => {
    appstore.getState().setShowTyping(false);
    // console.log("============>rexistingMessage", data);
    const checkMessageType = (data) => {
      // Parse the JSON string
      try {
        const parsedObject = JSON.parse(data);

        // Check if parsedObject has the expected properties
        return parsedObject;
      } catch (error) {
        return data;
      }
    };

    data.messages.map((message) => {
      return get().messageTypev2(
        checkMessageType(message),
        message.identity === "USER" ? true : false,
        message.time
      );
    });
  },

  getShopifyCart: async (mycart={}) => {
    try {
      
      let tempList = [];
      const response = mycart
      // console.log("Before For loop", tempList, response);
      get().setCart(response);
      response.items.forEach((ele) => {
        tempList.push(ele.product_id);
      });
      localStorage.setItem("cartList", tempList);
      get().setCartList(tempList);
      return tempList;
    } catch (error) {
      return error;
    }
  },
  updateShopifyCart: async (response) => {
    if (get().botDetails.storeName === "Shopify") {
      try {
        // console.log("Entered to getshopifycart");
        let tempList = [];
     
        get().setCart(response);
        response?.items?.forEach((ele) => {
          tempList.push(ele?.product_id);
        });
        localStorage.setItem("cartList", tempList);
        get().setCartList(tempList);
        return tempList;
      } catch (error) {
        return error;
      }
    } else if (get().botDetails.storeName === "Bigcommerce") {
      try {
        // console.log("Entered to getshopifycart");
        let tempList = [];
        if (response && response.length !== 0) {
          get().setCart(response[0]);
          localStorage.setItem("cartId", response[0].id);
        } else {
          localStorage.removeItem("cartId");
          localStorage.removeItem("cartList", []);
        }

        if (response[0] && response[0].lineItems.physicalItems) {
          response[0].lineItems.physicalItems.forEach((ele) => {
            tempList.push(ele?.productId);
          });
          localStorage.setItem("cartList", tempList);
          get().setCartList(tempList);
          return tempList;
        } else {
          localStorage.setItem("cartList", []);
          get().setCartList(tempList);
          return tempList;
        }
      } catch (error) {
        return error;
      }
    }
  },

  getBigcommerceCart: async (mycart={}) => {
 
      let tempList = [];
      const response=mycart
     
      if (response && response.length !== 0) {
        get().setCart(response[0]);
        localStorage.setItem("cartId", response[0]?.id);
      } else {
        localStorage.removeItem("cartId");
        localStorage.removeItem("cartList", []);
      }

      if (response[0] && response[0].lineItems.physicalItems) {
        response[0].lineItems.physicalItems.forEach((ele) => {
          tempList.push(ele?.productId);
        });
        localStorage.setItem("cartList", tempList);
        get().setCartList(tempList);
        return tempList;
      } else {
        localStorage.setItem("cartList", []);
        get().setCartList(tempList);
        return tempList;
      }
    
  },
  addCreateCartUlai: async (
    token,
    userId,
    productArray,
    totalPrice,
    subtotalPrice
  ) => {
    let newCartData = JSON.stringify({
      userId: userId,
      cartToken: token,
      totalPrice: totalPrice,
      subtotalPrice: subtotalPrice,
      productDetails: productArray,
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
    });
    let newCartConfig = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/cart/websdk`,
      headers: {
        "Content-Type": "application/json",
        xAuthKey:
          "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
      },
      data: newCartData,
    };
    try {
      await axios.request(newCartConfig);
    } catch (error) {}
  },
  handleQty: async (qty, varientId, productId, itemId, method) => {
    if (get().botDetails.storeName === "Shopify") {
      let isFound = false;
      let quantity = 0;
      get().mycart?.items.map((el) => {
        if (el.product_id == productId && el.variant_id == varientId) {
          isFound = true;
          quantity = el.quantity;
        }
      });
      if (isFound) {
        let item = {
          id: `${varientId}`,
          quantity:
            method == "Add"
              ? quantity + qty
              : method == "Minus"
              ? quantity - qty
              : qty,
        };
        const response = await axios
          .post( `${this.origin}`+`${this.cartId}` + "cart/change.js", item, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(async (response) => {
            const resp = await axios(
               `${this.origin}`+`${this.cartId}` + "cart.js",
              {
                method: "GET",
              }
            );

            let cart = await resp.data;
            get().updateShopifyCart(cart);
            let productArray = [];
            cart.items.forEach((element) => {
              productArray.push({
                productId: element.product_id,
                quantity: element.quantity,
                varient: [{ varientId: element.variant_id }],
              });
            });
            let totalPrice = cart?.total_price.toString();
            let subTotal = cart?.items_subtotal_price.toString();
            get().addCreateCartUlai(
              cart.token,
              get().botDetails?.userId,
              productArray,
              Number(
                `${totalPrice.slice(
                  0,
                  totalPrice.length - 2
                )}.${totalPrice.slice(-2)}`
              ),
              Number(
                `${subTotal.slice(0, subTotal.length - 2)}.${subTotal.slice(
                  -2
                )}`
              )
            );
          })
          .catch((error) => {
            return error;
          });
      } else {
        let item = {
          id: `${varientId}`,
          quantity: qty,
        };
        const response = await axios
          .post(
             `${this.origin}`+`${this.cartId}` + "cart/add.js",
            { items: [item] },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then(async (response) => {
            const resp = await axios(
               `${this.origin}`+`${this.cartId}` + "cart.js",
              {
                method: "GET",
              }
            );

            let cart = await resp.data;
            get().updateShopifyCart(cart);
            let productArray = [];
            cart.items.forEach((element) => {
              productArray.push({
                productId: element.product_id,
                quantity: element.quantity,
                varient: [{ varientId: element.variant_id }],
              });
            });
            let totalPrice = cart?.total_price.toString();
            let subTotal = cart?.items_subtotal_price.toString();
            get().addCreateCartUlai(
              cart.token,
              get().botDetails?.userId,
              productArray,
              Number(
                `${totalPrice.slice(
                  0,
                  totalPrice.length - 2
                )}.${totalPrice.slice(-2)}`
              ),
              Number(
                `${subTotal.slice(0, subTotal.length - 2)}.${subTotal.slice(
                  -2
                )}`
              )
            );
          })
          .catch((error) => {
            return error;
          });
      }
    } else if (get().botDetails.storeName === "Bigcommerce") {
      let isFound = false;
      let itemId = "";
      get().mycart.lineItems?.physicalItems.map((el) => {
        if (el.product_id == productId && el.variant_id == varientId) {
          isFound = true;
          itemId = el.id;
        }
      });
      if (isFound) {
        const options = {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: `{"lineItem":{"quantity":${qty},"productId":${productId},"variantId":${varientId}}}`,
        };

        // console.log("localStorage", localStorage.getItem("cartId"));
        const response = await fetch(
          `/api/storefront/carts/${localStorage.getItem(
            "cartId"
          )}/items/${itemId}?include=lineItems.physicalItems.options`,
          options
        )
          .then((response) => response.json())
          .catch((err) => console.error(err));

        if (response) {
          let tempList = [];
          let productArray = [];
          response.lineItems?.physicalItems?.forEach((element) => {
            tempList.push(element?.productId);
            productArray.push({
              productId: element?.productId,
              quantity: element?.quantity,
              varient: [{ varientId: element?.variantId }],
            });
          });
          let totalPrice = response?.cartAmount;
          let subTotal = response?.baseAmount?.toString();

          get().addCreateCartUlai(
            response?.id,
            get().botDetails?.userId,
            productArray,
            totalPrice,
            subTotal
          );
        }
      } else {
        const options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: `{"lineItems":[{"quantity":${qty},"productId":${productId},"variantId":${varientId}}]}`,
        };
        const response = await fetch(
          localStorage.getItem("cartId")
            ? `/api/storefront/carts/${localStorage.getItem(
                "cartId"
              )}/items?include=lineItems.physicalItems.options`
            : "/api/storefront/carts?include=lineItems.physicalItems.options",
          options
        )
          .then((response) => response.json())
          .catch((err) => console.error(err));
        if (response) {
          console.log("response", response);
          let tempList = [];
          let productArray = [];
          response.lineItems?.physicalItems?.forEach((element) => {
            tempList.push(element?.productId);
            productArray.push({
              productId: element?.productId,
              quantity: element?.quantity,
              varient: [{ varientId: element?.variantId }],
            });
          });
          let totalPrice = response?.cartAmount;
          let subTotal = response?.baseAmount?.toString();

          get().addCreateCartUlai(
            response?.id,
            get().botDetails?.userId,
            productArray,
            totalPrice,
            subTotal
          );
        }
      }
    }
  },
  
}));
export default appstore;
